// src/components/site-editor/InlineCallout.js
import React from 'react';
import { Lightbulb } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * InlineCallout - Contextual Playbook tip for Site Editor panels
 *
 * Usage:
 * <InlineCallout
 *   text="Feeling uncertain about pricing? You're not alone — most practitioners do at first."
 *   playbookTopic="earning-and-pricing"
 * />
 */
const InlineCallout = ({ text, playbookTopic = '' }) => {
  const playbookUrl = playbookTopic
    ? `/business-playbook/${playbookTopic}`
    : '/business-playbook';

  return (
    <div style={{
      background: '#FEF9EF',
      border: '1px solid #F5E6C8',
      borderRadius: '8px',
      padding: '16px'
    }}>
      <div className="flex gap-3">
        {/* Icon */}
        <div className="flex-shrink-0 mt-0.5">
          <Lightbulb className="w-5 h-5" style={{ color: '#bb9749' }} />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-2">
            {text}
          </p>
          <Link
            to={playbookUrl}
            className="text-sm font-medium transition-colors inline-flex items-center gap-2 flex-nowrap whitespace-nowrap"
            style={{ color: '#bb9749' }}
            onMouseEnter={(e) => e.target.style.color = '#a08340'}
            onMouseLeave={(e) => e.target.style.color = '#bb9749'}
          >
            Read more in the Playbook →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InlineCallout;
